import axios from "axios";

// Backend error responses are `{ serviceId, errorCode, errorValues, message }`; errorCode 0 means "no code".
// Older or proxied responses may instead carry a code such as "USR-232" inside a string.
export const getApiErrorCode = (error: unknown) => {
  const body = axios.isAxiosError(error) ? error.response?.data : undefined;
  if (body && typeof body === "object") {
    const { serviceId, errorCode } = body as { serviceId?: unknown; errorCode?: unknown };
    if (typeof serviceId === "string" && serviceId && typeof errorCode === "number" && errorCode > 0) {
      return `${serviceId}-${errorCode}`;
    }
  }
  return (typeof body === "string" ? body : JSON.stringify(body ?? "")).match(/[A-Z]{3}-\d{3}/)?.[0];
};

export const getApiErrorStatus = (error: unknown) => (axios.isAxiosError(error) ? error.response?.status : undefined);
